<div class="flex items-center gap-12 sm:gap-4 xl:justify-end justify-between
">
  <!-- Previous Button -->
  <button
    (click)="handlePageChange(uiCurrent() - 1)"
    [disabled]="uiCurrent() === 1"
    class="flex h-10 items-center gap-2 rounded-lg border border-gray-300 bg-white p-2 sm:p-2.5 text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <lib-icon name="arrow-left"></lib-icon>
  </button>

  <!-- Mobile Page Info -->
  <span class="text-sm font-medium text-gray-700 sm:hidden">
    Pág <b>{{ uiCurrent() }}</b> de <b>{{ totalPages() }}</b>
  </span>

  <!-- Page Numbers -->
  <ul class="hidden sm:flex items-center gap-1">
    @let total = totalPages();
    @let current = uiCurrent();

    @if (total <= 7) {
      @for (p of [1, 2, 3, 4, 5, 6, 7]; track p) {
        @if (p <= total) {
          <li>
            <button
              (click)="handlePageChange(p)"
              class="px-4 py-2 flex w-10 items-center justify-center h-10 rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500"
              [ngClass]="{
                'bg-brand-500 text-white': current === p,
                'text-gray-700 dark:text-gray-400': current !== p
              }"
            >
              {{ p }}
            </button>
          </li>
        }
      }
    } @else {
      <!-- Fixed size 7 logic -->
      <!-- Slot 1: Always 1 -->
      <li>
        <button
          (click)="handlePageChange(1)"
          class="px-4 py-2 flex w-10 items-center justify-center h-10 rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500"
          [ngClass]="{
            'bg-brand-500 text-white': current === 1,
            'text-gray-700 dark:text-gray-400': current !== 1
          }"
        >
          1
        </button>
      </li>

      <!-- Slot 2: 2 or ... -->
      <li>
        @if (current < 5) {
          <button
            (click)="handlePageChange(2)"
            class="px-4 py-2 flex w-10 items-center justify-center h-10 rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500"
            [ngClass]="{
              'bg-brand-500 text-white': current === 2,
              'text-gray-700 dark:text-gray-400': current !== 2
            }"
          >
            2
          </button>
        } @else {
          <div
            class="flex items-center justify-center w-10 h-10 text-sm font-medium text-gray-700 dark:text-gray-400"
          >
            ...
          </div>
        }
      </li>

      <!-- Slots 3, 4, 5 -->
      @let middleStart = current < 5 ? 3 : (current > total - 4 ? total - 4 : current - 1);
      @for (p of [middleStart, middleStart + 1, middleStart + 2]; track p) {
        <li>
          <button
            (click)="handlePageChange(p)"
            class="px-4 py-2 flex w-10 items-center justify-center h-10 rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500"
            [ngClass]="{
              'bg-brand-500 text-white': current === p,
              'text-gray-700 dark:text-gray-400': current !== p
            }"
          >
            {{ p }}
          </button>
        </li>
      }

      <!-- Slot 6: total-1 or ... -->
      <li>
        @if (current > total - 4) {
          <button
            (click)="handlePageChange(total - 1)"
            class="px-4 py-2 flex w-10 items-center justify-center h-10 rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500"
            [ngClass]="{
              'bg-brand-500 text-white': current === total - 1,
              'text-gray-700 dark:text-gray-400': current !== total - 1
            }"
          >
            {{ total - 1 }}
          </button>
        } @else {
          <div
            class="flex items-center justify-center w-10 h-10 text-sm font-medium text-gray-700 dark:text-gray-400"
          >
            ...
          </div>
        }
      </li>

      <!-- Slot 7: total -->
      <li>
        <button
          (click)="handlePageChange(total)"
          class="px-4 py-2 flex w-10 items-center justify-center h-10 rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500"
          [ngClass]="{
            'bg-brand-500 text-white': current === total,
            'text-gray-700 dark:text-gray-400': current !== total
          }"
        >
          {{ total }}
        </button>
      </li>
    }
  </ul>

  <!-- Next Button -->
  <button
    (click)="handlePageChange(uiCurrent() + 1)"
    [disabled]="uiCurrent() === totalPages()"
    class="flex h-10 items-center gap-2 rounded-lg border border-gray-300 bg-white p-2 sm:p-2.5 text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <lib-icon name="arrow-right"></lib-icon>
  </button>
</div>
